import { Stack, styled } from "@mui/material";

const Container = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  minHeight: "100%",
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #DBDDE0",
  paddingLeft: theme.spacing(0),
  paddingRight: theme.spacing(0),
  margin: "auto",
  overflow: "auto",
  maxHeight: `calc(100% - 0px)`,
  flexGrow: 1,
  background: "#fff",
}));

export default Container;